import { Link } from 'react-router-dom';
import styles from './styles.module.css';
import Description from './description';

function CardTabelas({ dataSet, onClick }) {
  return (
    <>
      {dataSet.map((tabela) => (
        <div className={styles.Card} key={tabela._id}>
          <div className={styles.ResultsCard}>
            <Link
              to="/result"
              target="_blank"
              rel="noreferrer noopener"
              onClick={() => onClick(tabela)}
              className={styles.ResultsCardTitle}
            >
              {tabela._source.tabela}
            </Link>
            <span
              className={`mdn-Icon-link-externo mdn-Icon--md ${styles.ResultsCardIcon}`}
            />
          </div>

          <Description value={tabela._source.descr} />
        </div>
      ))}
    </>
  );
}

export default CardTabelas;
